import { useToast } from '@televet/kibble-ui/build/components/Toast';

export enum STATUSES {
  info = 'info',
  warning = 'warning',
  success = 'success',
  error = 'error',
}

export const useCustomToast = (): {
  toastMessagePop: (description?: string, status?: STATUSES, duration?: number) => void;
} => {
  const toast = useToast();

  const toastMessagePop = (description = 'Changes Saved!', status = STATUSES.success, duration = 5000): void => {
    toast({
      description,
      position: 'top',
      status,
      duration,
    });
  };

  return { toastMessagePop };
};
